import { render, staticRenderFns } from "./LdExceedingDailyTextLimitsBanner.vue?vue&type=template&id=a15d9730&scoped=true"
import script from "./LdExceedingDailyTextLimitsBanner.vue?vue&type=script&lang=js"
export * from "./LdExceedingDailyTextLimitsBanner.vue?vue&type=script&lang=js"
import style0 from "./LdExceedingDailyTextLimitsBanner.vue?vue&type=style&index=0&id=a15d9730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15d9730",
  null
  
)

export default component.exports